import { combineReducers } from "redux";
import endpointReducer from "./endpontReducer";
import activateDeviceReducer from "./activateDeviceReducer";
import ipAddressReducer from "./ipAddressReducer";
import qrCodeReducer from "./qrCodeReducer";
import loginQrReducer from "./loginQrReducer";
import xStreamUrlVerifyReducer from "./xStreamUrlReducer";
import m3uReducer from "./m3uReducer";
import liveTvChannelReducer from "./liveTvChannelReducers";
import userLoginReducer from "./userLoginReducer";
import liveCategoryReducer from "./liveCategoryReducer";
import videojsReducer from "./videojsReducer";
import { networkReducer } from "./networkReducer";
import movieReducer from "./moviesReducer/movieReducer";
import seriesReducer from "./seriesReducer";
import catchupReducer from "./catchupReducer";
import prantalControlReducer from "./usersettingReducer/prantalControlReducer";
import toastReducer from "./toastReducer";

export const rootReducer = combineReducers({
  endpointReducer,
  activateDeviceReducer,
  ipAddressReducer,
  qrCodeReducer,
  loginQrReducer,
  xStreamUrlVerifyReducer,
  m3uReducer,
  liveTvChannelReducer,
  userLoginReducer,
  liveCategoryReducer,
  videojsReducer,
  networkReducer,
  movieReducer,
  seriesReducer,
  catchupReducer,
  prantalControlReducer,
  // toastReducer,
});
